// extracted by mini-css-extract-plugin
export var fadeIn = "_dp-1";
export var modalContent = "_dp-3";
export var overlay = "_dp-0";
export var popoverContent = "_dp-2";
export var results = "_dp-5";
export var searchInputWrapper = "_dp-4";